module.exports = __webpack_public_path__ + "static/media/icon_mypage_sp.726db615.svg";